// extracted by mini-css-extract-plugin
export default {"listSidePage":"HkVDs","footerContent":"OKo9p","footerContentText":"dtbxB"};